import { Theme } from '@eversports/react-components/design-tokens/theme'
import Card from '@eversports/react-components/primitives/Card'
import Flex from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

import BookableItem from '../../../typings/BookableItem'
import { SettleWith } from '../../../typings/Product'
import BookableItemBookingDetailsContent from '../common/BookableItemBookingDetailsContent'
import BookingDetailsImage from '../common/BookingDetailsImage'

interface Props {
  bookableItem: BookableItem
  settleWith?: SettleWith | null
}

const useStyles = makeStyles((theme: Theme) => ({
  activityInformation: {
    flex: '60%',
    padding: theme.layoutSpacing.wide,
  },
}))

const DesktopBookableItemBookingDetails: React.FC<React.PropsWithChildren<Props>> = ({ bookableItem, settleWith }) => {
  const classes = useStyles()

  return (
    <Card raised>
      <Flex justifyContent="space-between">
        <div className={classes.activityInformation}>
          <BookableItemBookingDetailsContent bookableItem={bookableItem} settleWith={settleWith} />
        </div>
        {bookableItem.activityImage && <BookingDetailsImage src={bookableItem.activityImage.large} />}
      </Flex>
    </Card>
  )
}

export default React.memo(DesktopBookableItemBookingDetails)
